import { Card, List, Space, Tag, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { type UserGroupSpecsFragment } from '../../../api/fragments/UserGroupSpecs';
import UserGroupSuperiorGroupEmptyList from './UserGroupSuperiorGroupEmptyList';

export type SuperiorUserGroupListProps = { userGroup: UserGroupSpecsFragment };

const SuperiorUserGroupList = ({ userGroup }: SuperiorUserGroupListProps) => {
    const { t } = useTranslation(['userGroupDetails']);

    if (userGroup.superiorUserGroups.length === 0) {
        return <UserGroupSuperiorGroupEmptyList userGroup={userGroup} />;
    }

    const companyTag = (displayName: string) => (
        <Tag color="green">
            <Space>
                <Typography.Text style={{ color: 'inherit' }} strong>
                    {t('userGroupDetails:companyTagLabel')}
                </Typography.Text>
                <Typography.Text style={{ color: 'inherit' }}>{displayName}</Typography.Text>
            </Space>
        </Tag>
    );

    return (
        <Card>
            <List size="small">
                {userGroup.superiorUserGroups.map(superiorUserGroup => (
                    <List.Item key={superiorUserGroup.id}>
                        <List.Item.Meta
                            description={
                                <Space direction="vertical" style={{ width: '100%' }}>
                                    <span>{superiorUserGroup.description}</span>
                                    {companyTag(superiorUserGroup.company.displayName)}
                                </Space>
                            }
                            title={superiorUserGroup.displayName}
                        />
                    </List.Item>
                ))}
            </List>
        </Card>
    );
};

export default SuperiorUserGroupList;
